// extracted by mini-css-extract-plugin
export default {"friends":"Friends_friends__tGcWl","friend":"Friends_friend__NWsTL","friendsInfo":"Friends_friendsInfo__r356R","friendsImage":"Friends_friendsImage__N1BJS"};